var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Information"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,1A15,15,0,1,1,1,16,15,15,0,0,1,16,1Zm0,2A13,13,0,1,0,29,16,13,13,0,0,0,16,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.15,8.61A1.8,1.8,0,0,1,16,6.79a1.77,1.77,0,0,1,1.79,1.82A1.78,1.78,0,0,1,16,10.43,1.8,1.8,0,0,1,14.15,8.61Zm.53,3.84h2.58v12.2H14.68Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.8d43eba2.svg";
export { ForwardRef as ReactComponent };